import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.infra.project.info');
import { OnInit, OnDestroy, Input, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-infra-project-info',
template: templateSource || '',
    styles: [`

/* file: /opt/season-cloud-manager/project/main/build/src/app/portal.infra.project.info/view.scss */
/* src/app/portal.infra.project.info/view.scss: no such file or directory */`],
})
export class PortalInfraProjectInfoComponent implements OnInit, OnDestroy {
    @Input() id: any;
    @Input() role: any;
    @Input() data: any = {};
    @Input() hosts: any = [];
    @Input() ipList: any = [];
    @Input() ipUsage: any = {};
    @Input() ownerInfo: any = null;
    @Input() refresh: any;

    public deleteString: any = false;

    // Category autocomplete
    public categories: string[] = [];
    public groups: any[] = [];
    public filteredCategories: string[] = [];
    public showCategoryDropdown: boolean = false;
    public categoryHighlightIndex: number = -1;
    public groupSearchText: string = '';
    public filteredGroups: any[] = [];
    public showGroupDropdown: boolean = false;
    public groupHighlightIndex: number = -1;

    // Host management
    public zones: any = [];
    public newdns: any = { name: "", basehost: "" };
    public zoneSearch: string = '';
    public showZoneDropdown: boolean = false;
    public filteredZones: string[] = [];
    public zoneHighlightIndex: number = -1;

    // Emoji picker
    public iconMode: string = 'emoji'; // 'emoji' | 'upload'
    public showEmojiPicker: boolean = false;
    public emojiCategory: string = 'Smileys';
    public emojiCategories: any = {
        'Smileys': ['😀','😃','😄','😁','😆','😅','🤣','😂','🙂','🙃','😉','😊','😇','🥰','😍','🤩','😘','😗','😚','😙','🥲','😋','😛','😜','🤪','😝','🤑','🤗','🤭','🤫','🤔','🫡','🤐','🤨','😐','😑','😶','🫥','😏','😒','🙄','😬','🤥','😌','😔','😪','🤤','😴','😷','🤒','🤕','🤢','🤮','🥴','😵','🤯','🥳','🥸','😎','🤓','🧐'],
        'Gestures': ['👋','🤚','🖐️','✋','🖖','🫱','🫲','🫳','🫴','👌','🤌','🤏','✌️','🤞','🫰','🤟','🤘','🤙','👈','👉','👆','👇','☝️','👍','👎','✊','👊','🤛','🤜','👏','🙌','🫶','👐','🤲','🤝','🙏'],
        'Animals': ['🐶','🐱','🐭','🐹','🐰','🦊','🐻','🐼','🐻‍❄️','🐨','🐯','🦁','🐮','🐷','🐸','🐵','🙈','🙉','🙊','🐒','🐔','🐧','🐦','🐤','🐣','🦆','🦅','🦉','🦇','🐺','🐗','🐴','🦄','🐝','🐛','🦋','🐌','🐞','🐜','🪲','🪳','🦂','🐢','🐍','🦎','🦖','🦕','🐙','🦑','🦐','🦞','🦀','🐳','🐋','🐬','🐟','🐠','🐡','🦈','🪸'],
        'Food': ['🍎','🍐','🍊','🍋','🍌','🍉','🍇','🍓','🫐','🍈','🍒','🍑','🥭','🍍','🥥','🥝','🍅','🍆','🥑','🫛','🥦','🥬','🥒','🌶️','🫑','🌽','🥕','🧄','🧅','🥔','🍠','🫘','🥐','🥖','🍞','🥨','🥯','🧀','🥚','🍳','🧈','🥞','🧇','🥓','🥩','🍗','🍖','🦴','🌭','🍔','🍟','🍕','🫓','🥪','🥙','🧆','🌮','🌯','🫔','🥗','🥘'],
        'Activities': ['⚽','🏀','🏈','⚾','🥎','🎾','🏐','🏉','🥏','🎱','🪀','🏓','🏸','🏒','🏑','🥍','🏏','🪃','🥅','⛳','🪁','🏹','🎣','🤿','🥊','🥋','🎽','🛹','🛼','🛷','⛸️','🥌','🎿','⛷️','🏂','🪂','🏋️','🤸','🤺','🤾','🏌️','🏇','🧘','🏄','🏊','🤽','🚣','🧗','🚵','🚴','🏆','🥇','🥈','🥉','🏅','🎖️','🏵️','🎗️','🎫','🎟️','🎪','🎭','🎨','🎬','🎤','🎧','🎼','🎹','🥁','🪘','🎷','🎺','🪗','🎸','🪕','🎻'],
        'Travel': ['🚗','🚕','🚙','🚌','🚎','🏎️','🚓','🚑','🚒','🚐','🛻','🚚','🚛','🚜','🏍️','🛵','🚲','🛴','🛺','🚔','🚍','🚘','🚖','🛞','🚡','🚠','🚟','🚃','🚋','🚞','🚝','🚄','🚅','🚆','🚇','🚈','🚉','✈️','🛫','🛬','🛩️','💺','🛰️','🚀','🛸','🚁','🛶','⛵','🚤','🛥️','🛳️','⛴️','🚢','🗼','🏰','🏯','🏟️','🎡','🎢','🎠','⛲','⛱️','🏖️','🏝️','🏜️','🌋','⛰️','🏔️','🗻','🏕️','🏠','🏡','🏢','🏬','🏭','🏗️','🏛️'],
        'Objects': ['⌚','📱','📲','💻','⌨️','🖥️','🖨️','🖱️','🖲️','🕹️','🗜️','💽','💾','💿','📀','📼','📷','📸','📹','🎥','📽️','🎞️','📞','☎️','📟','📠','📺','📻','🎙️','🎚️','🎛️','🧭','⏱️','⏲️','⏰','🕰️','💡','🔦','🕯️','🪔','📡','🔋','🪫','🔌','💰','🪙','💴','💵','💶','💷','🏧','💎','⚖️','🪜','🧰','🪛','🔧','🔨','⚒️','🛠️','⛏️','🪚','🔩','⚙️','🗑️','📦'],
        'Symbols': ['❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔','❤️‍🔥','❤️‍🩹','💕','💞','💓','💗','💖','💘','💝','💟','☮️','✝️','☪️','🕉️','☸️','✡️','🔯','🕎','☯️','☦️','🛐','⛎','♈','♉','♊','♋','♌','♍','♎','♏','♐','♑','♒','♓','🆔','⚛️','💯','💢','♨️','🚷','🚯','🚳','🚱','🔞','📵','🚭','❗','❕','❓','❔','‼️','⁉️','🔅','🔆','〽️','⚠️','🔱','⚜️','🔰','♻️','✅','💹','❇️','✳️','❎','🌐','💠','🌀','💤']
    };

    // Document click handler
    private _docClickBound: any = null;

    constructor(@Inject( Service) public service: Service,@Inject( ElementRef)  private eRef: ElementRef) { }

    public async ngOnInit() {
        await this.service.init();
        this._docClickBound = this._onDocumentClick.bind(this);
        document.addEventListener('click', this._docClickBound);
        await this.load();
    }

    public ngOnDestroy() {
        if (this._docClickBound) {
            document.removeEventListener('click', this._docClickBound);
        }
    }

    private _onDocumentClick(event: MouseEvent) {
        const target = event.target as HTMLElement;
        // Close category dropdown if click is outside
        if (this.showCategoryDropdown) {
            const catContainer = this.eRef.nativeElement.querySelector('.category-dropdown-container');
            if (catContainer && !catContainer.contains(target)) {
                this.showCategoryDropdown = false;
                this.categoryHighlightIndex = -1;
                this.service.render();
            }
        }
        // Close group dropdown if click is outside
        if (this.showGroupDropdown) {
            const groupContainer = this.eRef.nativeElement.querySelector('.group-dropdown-container');
            if (groupContainer && !groupContainer.contains(target)) {
                this.closeGroupDropdown(true);
                this.service.render();
            }
        }
        // Close zone dropdown if click is outside
        if (this.showZoneDropdown) {
            const zoneContainer = this.eRef.nativeElement.querySelector('.zone-dropdown-container');
            if (zoneContainer && !zoneContainer.contains(target)) {
                this.showZoneDropdown = false;
                this.zoneHighlightIndex = -1;
                this.service.render();
            }
        }
        // Close emoji picker if click is outside
        if (this.showEmojiPicker) {
            const emojiContainer = this.eRef.nativeElement.querySelector('.emoji-picker-container');
            if (emojiContainer && !emojiContainer.contains(target)) {
                this.showEmojiPicker = false;
                this.service.render();
            }
        }
    }

    public async load() {
        await this.loadCategories();
        await this.loadGroups();
        if (this.data && this.data.id) {
            await this.loadZones();
        }
        if (this.data && this.data.icon) {
            this.iconMode = 'upload';
        } else {
            this.iconMode = 'emoji';
        }
        await this.service.render();
    }

    public async loadCategories() {
        const { code, data } = await wiz.call("categories");
        if (code == 200) {
            this.categories = data;
        }
    }

    public async loadGroups() {
        const groupId = this.data?.group_id || '';
        const { code, data } = await wiz.call("groups", { group_id: groupId });
        if (code == 200) {
            this.groups = data || [];
            if (this.data?.group_info && !this.groups.find((g: any) => g.id === this.data.group_info.id)) {
                this.groups.push(this.data.group_info);
            }
            this.syncGroupSearchText();
        }
    }

    public async loadZones() {
        const { code, data } = await wiz.call("zone", { id: this.data.id });
        if (code == 200) {
            this.zones = data;
        }
    }

    // === Category autocomplete ===
    public onCategoryInput() {
        const input = (this.data.category || '').toLowerCase();
        if (input.length === 0) {
            this.filteredCategories = this.categories;
        } else {
            this.filteredCategories = this.categories.filter(c => c.toLowerCase().includes(input));
        }
        this.categoryHighlightIndex = -1;
        this.showCategoryDropdown = this.filteredCategories.length > 0;
        this.service.render();
    }

    public onCategoryFocus() {
        this.onCategoryInput();
    }

    public onCategoryBlur() {
        setTimeout(() => {
            this.showCategoryDropdown = false;
            this.categoryHighlightIndex = -1;
            this.service.render();
        }, 200);
    }

    public onCategoryKeydown(event: KeyboardEvent) {
        if (!this.showCategoryDropdown || this.filteredCategories.length === 0) return;

        if (event.key === 'ArrowDown') {
            event.preventDefault();
            this.categoryHighlightIndex = (this.categoryHighlightIndex + 1) % this.filteredCategories.length;
            this.service.render();
        } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            this.categoryHighlightIndex = this.categoryHighlightIndex <= 0
                ? this.filteredCategories.length - 1
                : this.categoryHighlightIndex - 1;
            this.service.render();
        } else if (event.key === 'Enter') {
            event.preventDefault();
            if (this.categoryHighlightIndex >= 0 && this.categoryHighlightIndex < this.filteredCategories.length) {
                this.selectCategory(this.filteredCategories[this.categoryHighlightIndex]);
            }
        } else if (event.key === 'Escape') {
            this.showCategoryDropdown = false;
            this.categoryHighlightIndex = -1;
            this.service.render();
        }
    }

    public selectCategory(cat: string) {
        this.data.category = cat;
        this.showCategoryDropdown = false;
        this.categoryHighlightIndex = -1;
        this.service.render();
    }

    // === Group searchable dropdown ===
    public getGroupDisplay(group: any): string {
        if (!group) return '';
        return group.name || group.id || '';
    }

    public getGroupSub(group: any): string {
        if (!group) return '';
        return group.id || '';
    }

    public getSelectedGroup(): any {
        if (!this.data?.group_id) return null;
        return this.groups.find((group: any) => group.id === this.data.group_id) || this.data?.group_info || null;
    }

    public getSelectedGroupDisplay(): string {
        const group = this.getSelectedGroup();
        if (!group) return this.data?.group_id || '';
        return this.getGroupDisplay(group);
    }

    private syncGroupSearchText() {
        this.groupSearchText = this.getSelectedGroupDisplay();
    }

    private filterGroups() {
        const input = (this.groupSearchText || '').toLowerCase();
        if (input.length === 0 || input === this.getSelectedGroupDisplay().toLowerCase()) {
            this.filteredGroups = this.groups;
        } else {
            this.filteredGroups = this.groups.filter((group: any) => {
                const name = (group.name || '').toLowerCase();
                const id = (group.id || '').toLowerCase();
                const ownerName = (group.owner_info?.name || '').toLowerCase();
                const ownerEmail = (group.owner_info?.email || '').toLowerCase();
                return name.includes(input) || id.includes(input) || ownerName.includes(input) || ownerEmail.includes(input);
            });
        }
    }

    private closeGroupDropdown(resetText: boolean = false) {
        this.showGroupDropdown = false;
        this.groupHighlightIndex = -1;
        if (resetText) {
            this.syncGroupSearchText();
        }
    }

    public onGroupInput() {
        this.filterGroups();
        this.groupHighlightIndex = -1;
        this.showGroupDropdown = true;
        this.service.render();
    }

    public onGroupFocus() {
        this.filterGroups();
        this.showGroupDropdown = true;
        const selectedIndex = this.filteredGroups.findIndex((group: any) => group.id === this.data?.group_id);
        this.groupHighlightIndex = selectedIndex >= 0 ? selectedIndex + 1 : -1;
        this.service.render();
    }

    public onGroupKeydown(event: KeyboardEvent) {
        if (!this.showGroupDropdown) {
            this.onGroupFocus();
        }

        const total = this.filteredGroups.length + 1;
        if (event.key === 'ArrowDown') {
            event.preventDefault();
            this.groupHighlightIndex = (this.groupHighlightIndex + 1) % total;
            this.service.render();
        } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            this.groupHighlightIndex = (this.groupHighlightIndex - 1 + total) % total;
            this.service.render();
        } else if (event.key === 'Enter') {
            event.preventDefault();
            if (this.groupHighlightIndex === 0) {
                this.selectGroup(null);
            } else if (this.groupHighlightIndex > 0 && this.groupHighlightIndex <= this.filteredGroups.length) {
                this.selectGroup(this.filteredGroups[this.groupHighlightIndex - 1]);
            }
        } else if (event.key === 'Escape') {
            this.closeGroupDropdown(true);
            this.service.render();
        }
    }

    public selectGroup(group: any) {
        this.data.group_id = group?.id || '';
        this.closeGroupDropdown(false);
        this.syncGroupSearchText();
        this.service.render();
    }

    // === Icon / Emoji ===
    public switchIconMode(mode: string) {
        this.iconMode = mode;
        this.showEmojiPicker = false;
        this.service.render();
    }

    public toggleEmojiPicker() {
        this.showEmojiPicker = !this.showEmojiPicker;
        this.service.render();
    }

    public selectEmojiCategory(cat: string) {
        this.emojiCategory = cat;
        this.service.render();
    }

    public selectEmoji(emoji: string) {
        this.data.emoji = emoji;
        this.data.icon = '';
        this.showEmojiPicker = false;
        this.service.render();
    }

    public deleteEmoji() {
        this.data.emoji = '';
        this.service.render();
    }

    public async updateIcon() {
        this.data.icon = await this.service.file.read({ type: 'image', accept: 'image/*', width: 64, quality: 1 });
        this.data.emoji = '';
        this.iconMode = 'upload';
        await this.service.render();
    }

    public async deleteIcon() {
        this.data.icon = "";
        await this.service.render();
    }

    // === Host management ===
    public onZoneInput() {
        const input = (this.newdns.basehost || '').toLowerCase();
        if (input.length === 0) {
            this.filteredZones = this.zones;
        } else {
            this.filteredZones = this.zones.filter((z: string) => z.toLowerCase().includes(input));
        }
        this.zoneHighlightIndex = -1;
        this.showZoneDropdown = this.filteredZones.length > 0;
        this.service.render();
    }

    public onZoneFocus() { this.onZoneInput(); }

    public onZoneBlur() {
        setTimeout(() => {
            this.showZoneDropdown = false;
            this.zoneHighlightIndex = -1;
            this.service.render();
        }, 200);
    }

    public onZoneKeydown(event: KeyboardEvent) {
        if (!this.showZoneDropdown || this.filteredZones.length === 0) return;
        if (event.key === 'ArrowDown') {
            event.preventDefault();
            this.zoneHighlightIndex = (this.zoneHighlightIndex + 1) % this.filteredZones.length;
            this.service.render();
        } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            this.zoneHighlightIndex = this.zoneHighlightIndex <= 0
                ? this.filteredZones.length - 1
                : this.zoneHighlightIndex - 1;
            this.service.render();
        } else if (event.key === 'Enter') {
            event.preventDefault();
            if (this.zoneHighlightIndex >= 0 && this.zoneHighlightIndex < this.filteredZones.length) {
                this.selectZone(this.filteredZones[this.zoneHighlightIndex]);
            }
        } else if (event.key === 'Escape') {
            this.showZoneDropdown = false;
            this.zoneHighlightIndex = -1;
            this.service.render();
        }
    }

    public selectZone(zone: string) {
        this.newdns.basehost = zone;
        this.showZoneDropdown = false;
        this.zoneHighlightIndex = -1;
        this.service.render();
    }

    public hostName(item: any): string {
        if (!item) return '';
        if (item.host) return item.host;
        const name = (item.name || '').trim();
        const basehost = (item.basehost || '').trim();
        return name ? `${name}.${basehost}` : basehost;
    }

    public async addDNS() {
        this.newdns.id = this.data.id;
        const { code, data } = await wiz.call("add_dns", this.newdns);
        if (code == 200) {
            await this.refresh();
            this.newdns = { name: "", basehost: "" };
        } else {
            await this.service.modal.error(data);
        }
        await this.service.render();
    }

    public async deleteDNS(item: any) {
        if (!await this.service.modal.error(`Are you sure delete '${this.hostName(item)}'?`, `Cancel`, `Delete`)) return;
        item.id = this.data.id;
        const { code, data } = await wiz.call("delete_dns", item);
        if (code == 200) {
            await this.refresh();
        } else {
            await this.service.modal.error(data);
        }
        await this.service.render();
    }

    // === IP management ===
    public async createIP() {
        await wiz.call("create_ip", { id: this.data.id });
        await this.refresh();
    }

    public async removeIP(item: any) {
        if (!await this.service.modal.error(`Are you sure delete '${item.ip}'?`, `Cancel`, `Delete`)) return;
        await wiz.call("remove_ip", { id: this.data.id, ip: item.ip });
        await this.refresh();
    }

    // === Delete project ===
    public async deleteProject() {
        if (this.deleteString) {
            if (this.data.name == this.deleteString) {
                if (!await this.service.modal.error(`Are you sure delete '${this.data.name}'?`, `Cancel`, `Delete`)) return;
                this.service.status.show("loading");
                try {
                    await wiz.call("delete", { id: this.data.id });
                } finally {
                    this.service.status.hide("loading");
                }
                await this.service.href("/project");
            } else {
                await this.service.modal.error(`Input valid project name`, `Cancel`, `Confirm`)
            }
        }
        this.deleteString = "";
        await this.service.render();
    }
}

export default PortalInfraProjectInfoComponent;